module.exports = "<i class=\"spark-icon--fill spark-icon-check checked\"></i>";